var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('div',{staticClass:"no-data-warning"},[_c('img',{attrs:{"src":_vm.bacData,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"no-data-text"},[_vm._v("暂无数据")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }